var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-primary my-2"},[_c('b-spinner',{staticClass:"align-middle"}),_c('strong',{staticClass:"pl-2"},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }